import { setData } from "./FieldHandler";

var selectorsReceived = {}

const EventHandler = {
    handleEvent: ({ selector, data, assistantId, cb=()=>{} , additionalInfo }, assistant) => {
      let initial = false;
      if(selectorsReceived[assistantId] == undefined){
        selectorsReceived[assistantId] = []
      }
      if(!selectorsReceived[assistantId].includes(selector)){
        initial = true;
        selectorsReceived[assistantId].push(selector)
      }
      const options = {
        initial, cb, additionalInfo
      }
      setData(assistant, data, options);
    },
    resetSelectorsReceived: (assistantId) => {
      selectorsReceived[assistantId] = [];
    }
  };
  

export default EventHandler;
